// extracted by mini-css-extract-plugin
export default {"page":"layout_page__06OxM","main":"layout_main__QNndr","home":"layout_home__0wcJo","whip":"layout_whip__lrEnk"};